<template>
    <v-container>
        <h1>Mes heures</h1>
              <v-btn
        class="mb-3 mr-3"
        color="secondary"
        @click="generatePDF()"
      >
        <v-icon left>  
          mdi-file-pdf-box
        </v-icon>
        Télécharger en PDF
      </v-btn>
       <v-dialog
        ref="dialog"
        :return-value.sync="date"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="date"
            :value="momentFormatted"
            label="Période salariale"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date"
          type="month"
          locale="fr"
          scrollable
          @change="onChange"
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="$refs.dialog.save(date)"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
        <p>Période du {{begin.format('DD/MM/YYYY')}} au {{end.format('DD/MM/YYYY')}}</p>
          <v-simple-table
                      :loading="loading"
            loading-text="Chargement...">
            <template v-slot:default>
            <thead>
                <tr>
                <th class="text-left">
                    Date
                </th>
                <th class="text-left">
                    Site
                </th>
                <th class="text-left">
                    Fonction
                </th>
                <th class="text-left">
                    A1-D1
                </th>
                <th class="text-left">
                    A2-D2
                </th>
                <th class="text-left">
                    A3-D3
                </th>
                <th class="text-left">
                    A4-D4
                </th>
                <th class="text-left">
                    A5-D5
                </th>
                <th class="text-left">
                    A6-D6
                </th>
                <th class="text-left">
                    Cumul
                </th>
                </tr>
            </thead>
            <tbody>
                <tr
                v-for="heure in heures"
                :key="heure.id"
                >
                <td>{{utils.toPrettyDate(heure.date)}}</td>
                <td>{{sitesById[heure.id_site].nom}}</td>
                <td>{{fonctionsById[heure.id_fonction].nom}}</td>
                <td>
                <plage-horaire :a="heure.a1" :d="heure.d1" />
                </td>
                <td>
                <plage-horaire :a="heure.a2" :d="heure.d2" />
                </td>
                <td>
                <plage-horaire :a="heure.a3" :d="heure.d3" />
                </td>
                <td>
                <plage-horaire :a="heure.a4" :d="heure.d4" />
                </td>
                <td>
                <plage-horaire :a="heure.a5" :d="heure.d5" />
                </td>
                <td>
                <plage-horaire :a="heure.a6" :d="heure.d6" />
                </td>
                <td>
                <b>{{toDecimalHour(heure.cumul)}}</b>
                </td>
                </tr>
            </tbody>
            </template>
        </v-simple-table>
        <v-card>
            <v-card-title>
                Résumé du mois
            </v-card-title>
            <v-card-text>
                <p>Total des heures (Normal): {{toDecimalHour(totalNormal)}}</p>
                <p>Total des heures (RHT): {{toDecimalHour(totalRHT)}}</p>
                <p style="color: black">Total des heures: {{toDecimalHour(total)}}</p>
            </v-card-text>
        </v-card>
    </v-container>
</template>


<script>
import api from "@/api";
import utils from "@/utils";
import PlageHoraire from "@/components/PlageHoraire";
import moment from "moment";

export default {
  data() {
    return {
      heures: [],
      sitesById: [],
      total: 0,
      totalNormal: 0,
      totalRHT: 0,
      fonctionsById: [],
      utils,
      begin: moment(),
      end: moment(),
      date: moment().format("yyyy-MM"),
      periodes: [],
    };
  },
   components: {  PlageHoraire },
  created() {
    this.asyncLoadData();
  },
  computed: {
      momentFormatted(){
          return this.date ? moment(this.date).format("MMMM") : '';
      }
  },
  methods: {
    async asyncLoadData(){
      let s = (await api.getSites()).data.sites;
      for (let site of s) {
        this.sitesById[site.id] = site;
      }
      let f = (await api.getFonctions()).data.fonctions;
      for (let fonction of f) {
        this.fonctionsById[fonction.id] = fonction;
      }
      this.periodes = (await api.getPeriodes()).data.periodes;
      let today = moment();
      let ok = false;
      for (let i = 0; i < this.periodes.length; i++) {
        let diff =
          moment(this.periodes[i][1]).year() - moment(this.periodes[i][0]).year();
        let a = moment(this.periodes[i][0]).set("year", today.year() - diff);
        let b = moment(this.periodes[i][1]).set("year", today.year());
        if (today.isBetween(a, b, undefined, "[]")) {
          today.set("month", i);
          ok = true;
          break;
        }
      }
      if (!ok) {
        today.add(1, "month");
      }
      this.date = today.format("yyyy-MM");
      this.onChange();
    },
    toDecimalHour(hours) {
      return (Math.round(moment.duration(hours).asHours() * 100) / 100).toFixed(
        2
      );
    },
    async onChange() {
      let month = moment(this.date).month();
      let year = moment(this.date).year();
      let diff =
        moment(this.periodes[month][1]).year() -
        moment(this.periodes[month][0]).year(); //On recale l'année des périodes sur l'année en cours
      this.begin = moment(this.periodes[month][0]).set("year", year - diff);
      this.end = moment(this.periodes[month][1]).set("year", year);
      this.loadData();
    },
    async loadData() {
      this.$store.commit("setLoading", true);
      let response = (
        await api.getHeures(this.begin.format("YYYY-MM-DD"), this.end.format("YYYY-MM-DD"))
      ).data;
      this.heures = response.heures;
      this.totalRHT = response.resume.totalRHT;
      this.totalNormal = response.resume.totalNormal;
      this.total = response.total;
      this.$store.commit("setLoading", false);
    },
    generatePDF() {
        console.log(this.begin.format("YYYY-MM-DD"));
      api.pdf(
        `heures`,
        {
          filters: {
            begindate: this.begin.format("YYYY-MM-DD"),
            enddate: this.end.format("YYYY-MM-DD"),
          },
        },
        `heures-${moment(this.date).year()}-${moment(this.date).month() + 1}`
      );
    },
  },
};
</script>